import gsap from 'gsap'
import UIkit from 'uikit'

let popinCarouselConfiguration = {
    /**
     * Component name
     * @type {String}
     */
    name: 'popin-carousel',

    /**
     * Component
     */
    $component: {},

    /** Data
     * @type {Object}
     */
    $data: {
        active: false,
        animated: false,
        carouselText: {},
        carouselVisuel: {},
        x: false
    },

    /**
     * Create components
     * @void
     */
    init () {
        console.log('POPIN CAROUSEL Initialized')
        this.$component = document.querySelector(`.${this.name}`)
        this.$data.animated = false
        this.$data.active = false

        // function
        this.attachEventsHandlers()
        this.initLightbox()
        this.disableClick()
    },

    /**
     * Attach event handlers
     */
    attachEventsHandlers () {
        this.$data.carouselText = this.$component.querySelectorAll('.text-item')
        this.$data.carouselVisuel = this.$component.querySelectorAll('.visuel-item')
        this.$data.animated = false
        let _start = 0
        let _dotNav = this.$component.querySelectorAll('.carousel-dotnav li')

        // Initialize components state
        if (this.$data.carouselVisuel && this.$data.carouselVisuel.length) {
            gsap.set(
                this.$data.carouselVisuel,
                {
                    zIndex: 1,
                    xPercent: 100
                }
            )
        }

        if (this.$data.carouselText && this.$data.carouselText) {
            gsap.set(
                this.$component.querySelectorAll('.info'),
                {
                    y: 300,
                    autoAlpha: 0
                }
            )
        }

        // attach dot-nav event
        if (_dotNav.length) {
            _dotNav.forEach(
                (nav, index) => {
                    let _link = nav.querySelector('a')

                    _link.addEventListener(
                        'click',
                        () => {
                            this.setActive(index)
                        }
                    )
                }
            )
        }

        // shift carousel
        document.addEventListener(
            'shiftCarousel',
            event => {
                let _outcoming = event.detail.outcoming
                let _incoming = event.detail.incoming

                this.shiftCarousel(_outcoming, _incoming)

                _dotNav.forEach(
                    (nav, index) => {
                        nav.classList.remove('active')

                        if (index === _incoming) {
                            nav.classList.add('active')
                        }
                    }
                )
            }
        )

        // window resize
        window.addEventListener(
            'resize',
            () => {
                this.initLightbox()
                this.disableClick()
            }
        )

        // Swipe
        this.$data
            .carouselVisuel
            .forEach(
                (slide, index) => {
                    slide.addEventListener(
                        'mousedown',
                        event => this.setX(event),
                        false
                    )

                    slide.addEventListener(
                        'touchstart',
                        event => this.setX(event),
                        false
                    )

                    slide.addEventListener(
                        'mouseup',
                        event => this.moveCarousel(event, index),
                        false
                    )

                    slide.addEventListener(
                        'touchend',
                        event => this.moveCarousel(event, index),
                        false
                    )
                }
            )

        // lightbox event
        UIkit.util
            .on(
                document,
                'itemshown',
                '.uk-lightbox',
                event => {
                    let _target = event.current
                    let _slideCount = _target.querySelector('.slide-count')
                    let _index = event.detail[0].index + 1
                    let _length = this.$data.carouselVisuel.length
                    let _count = `${_index}/${_length}`

                    document.body.classList.add('overflow-hidden')

                    if (_slideCount && _slideCount instanceof HTMLElement) {
                        _slideCount.innerHTML = _count
                        this.setActive(event.detail[0].index)
                    }
                }
            )

        UIkit.util
            .on(
                document,
                'hidden',
                '.uk-lightbox',
                () => {
                    document.body.classList.remove('overflow-hidden')
                }
            )

        // set active item
        this.setActive(_start)
    },

    setActive (index) {
        const UPDATE_EVENT = new CustomEvent(
            'shiftCarousel',
            {
                bubbles: true,
                detail: {
                    outcoming: this.$data.active,
                    incoming: index
                }
            }
        )

        if (this.$data.active !== index && !this.$data.animated) {
            this.$data.active = index
            document.dispatchEvent(UPDATE_EVENT)
        }
    },

    shiftCarousel (outcoming, incoming) {
        let _outText = this.$data.carouselText[outcoming]
        let _outVisuel = this.$data.carouselVisuel[outcoming]
        let _inText = this.$data.carouselText[incoming]
        let _inVisuel = this.$data.carouselVisuel[incoming]
        let _direction = outcoming < incoming ? -1 : 1
        let _timeline = gsap.timeline(
            {
                paused: true,
                onStart: () => {
                    this.$data.animated = true
                },
                onComplete: () => {
                    this.$data.animated = false
                }
            }
        )

        _timeline.addLabel('start')

        /**
         * Queue visuels
         */
        if (_outVisuel && _outVisuel instanceof HTMLElement) {
            _timeline.fromTo(
                _outVisuel,
                1.2,
                { zIndex: 1 },
                {
                    xPercent: 100 * _direction,
                    ease: 'power3.easeInOut'
                },
                'start'
            )
        }

        if (_inVisuel && _inVisuel instanceof HTMLElement) {
            _timeline.fromTo(
                _inVisuel,
                1,
                {
                    xPercent: -100 * _direction,
                    zIndex: 2
                },
                {
                    xPercent: 0,
                    ease: 'power1.easeInOut'
                },
                'start'
            )
        }

        /**
         * Queue infos
         */
        if (_outText && _outText instanceof HTMLElement) {
            _timeline.staggerTo(
                _outText.querySelectorAll('.info'),
                1,
                {
                    y: 300 * _direction,
                    autoAlpha: 0,
                    ease: 'power3.easeInOut'
                },
                {
                    from: _direction === 1 ? 'end' : 'start',
                    amount: 0.1,
                    each: 1,
                    ease: 'power1.easeOut'
                },
                'start'
            )
        }

        if (_inText && _inText instanceof HTMLElement) {
            _timeline.staggerFromTo(
                _inText.querySelectorAll('.info'),
                1,
                { y: -300 * _direction },
                {
                    delay: 0.2,
                    y: 0,
                    autoAlpha: 1,
                    ease: 'power3.easeInOut'
                },
                {
                    from: _direction === 1 ? 'end' : 'start',
                    amount: 0.1,
                    each: 1,
                    ease: 'power1.easeOut'
                },
                'start'
            )
        }

        _timeline
            .duration(2)
            .play()
    },

    initLightbox () {
        let _options = {
            template: `<div class="uk-lightbox uk-overflow-hidden">
                            <ul class="uk-lightbox-items"></ul>
                            <div class="uk-lightbox-toolbar uk-position-top uk-text-right uk-transition-slide-top uk-transition-opaque">
                                <button class="uk-lightbox-toolbar-icon uk-close-large" type="button" uk-close></button>
                            </div>
                            <div class="slide-toolbar">
                                <div class="slide-count"></div>
                                <a class="uk-lightbox-button uk-position-center-left uk-position-medium uk-transition-fade" href uk-slidenav-previous uk-lightbox-item="previous"></a>
                                <a class="uk-lightbox-button uk-position-center-right uk-position-medium uk-transition-fade" href uk-slidenav-next uk-lightbox-item="next"></a>
                            </div>
                            <div class="uk-lightbox-caption uk-position-bottom uk-text-center uk-transition-slide-bottom uk-transition-opaque"></div>
                        </div>`
        }

        if (window.innerWidth >= 992) {
            UIkit.lightbox(
                this.$component.querySelector('.carousel-visuel'),
                _options
            )
        }
    },

    disableClick () {
        if (window.innerWidth < 992) {
            this.$data
                .carouselVisuel
                .forEach(
                    slide => {
                        let _link = slide.querySelector('a')

                        _link.addEventListener(
                            'click',
                            event => {
                                event.preventDefault()
                            }
                        )
                    }
                )
        }
    },

    simplifyEvent (event) {
        return event.changedTouches ? event.changedTouches[0] : event
    },

    moveCarousel (event, index) {
        let _direction = this.simplifyEvent(event).clientX < this.$data.x
        let _length = (this.$data.carouselVisuel.length - 1)
        let active = 0

        if (_direction) {
            active = index + 1
        } else {
            active = index - 1
        }

        if (active >= 0 && active <= _length) {
            this.setActive(active)
        }
    },

    setX (event) {
        this.$data.x = this.simplifyEvent(event).clientX
    }
}

/**
 * Module export
 */
export default popinCarouselConfiguration
